import { FC } from 'react'
import { Spinner } from './Spinner'

const GlobalLoader: FC = () => {
  return (
    <div className="global-loader fixed top-0 left-0 w-full h-full flex items-center justify-center">
      <Spinner />
    </div>
  )
}

export default GlobalLoader
